module.exports = __webpack_public_path__ + "img/icon-rapidly.d6707f62.png";